// extracted by mini-css-extract-plugin
export default {"bodyDrawer":"Mk1EX0LyZbZvEirBSU7S","iconStyling":"LnetZ4Nj56lDOVg7R9Bj","titleText":"c9iM8_TQ23eTDjjrnytJ","titleBody":"QwN4xIu4wjUTnnTCsKSY"};